import { CgSpinnerTwo } from "react-icons/cg";

export default function Loader() {
  return <CgSpinnerTwo size={50} className="animate-spin text-green" />;
}
